module.exports = __webpack_public_path__ + "img/antes_despues_276.6292e54f.png";